import CustomerManagement from "./CustomerManagement";
// import ManagementSidebar from "components/common/ManagementSidebar";
// import Loader from "utils/Loader";
import Loader from "../utils/Loader";
import { useState } from "react";

const CustomerManagment = () => {
  const [isLoading, setIsLoading] = useState(true);
  return (
    <div className="d-flex">
      {isLoading && <Loader />}
      {/* <ManagementSidebar></ManagementSidebar> */}
      <CustomerManagement setIsLoading={setIsLoading} />
    </div>
  );
};

export default CustomerManagment;
